export default "__VITE_ASSET__BLHVpwVc__"